import "../../shared/sparkle_namespace.js";

window.Sparkle ??= {};

Sparkle.PatientJourneyManager = Sparkle.PatientJourneyManager || {};
